<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row>
          <v-col cols="12" md="4">
            <DateIOSPicker label="Ngày" :date.sync="time" outlined :rules="[$rules.date, $rules.dateFromNow]" dense />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              label="Chiều di chuyển"
              v-model="busTimeline"
              :items="busTimelines"
              item-text="title"
              item-value="value"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              label="Trạng thái"
              v-model="status"
              :items="busStudentAttendanceStatus"
              item-text="title"
              item-value="value"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-select
              label="Trạng thái đăng kí"
              v-model="register"
              :items="registerStatus"
              item-text="title"
              item-value="value"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </v-col> -->
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12">
            <GradeClassStudentSelect
              :gradeCol="{ cols: 12, md: 4 }"
              :classCol="{ cols: 12, md: 4 }"
              :studentCol="{ cols: 12, md: 4 }"
              @changed="gradeClassStudentChange"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { registerStatus } from './BusStudentTrackingFilter/helper'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'

export default {
  components: {
    GradeClassStudentSelect,
    DateIOSPicker
  },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      status: '',
      time: moment().toISOString(),
      busTimeline: '',
      //   register: null,
      registerStatus
    }
  },
  computed: {
    ...mapGetters('constant', ['busTimelines', 'busStudentAttendanceStatus'])
  },
  mounted() {
    const query = {
      createdAt_gte: moment()
        .startOf('day')
        .toISOString(),
      createdAt_lte: moment()
        .endOf('day')
        .toISOString()
    }
    this.fetch({
      _start: 0,
      _limit: 10,
      ...query
    })
    this.count(query)
    this.setState({ attribute: 'query', data: query })
  },
  methods: {
    ...mapActions({
      fetch: 'busStudentTracking/fetch',
      count: 'busStudentTracking/count'
    }),
    ...mapMutations({
      setState: 'busStudentTracking/setState'
    }),
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    async onFilterChanged() {
      if (this.$refs.form.validate()) {
        try {
          this.setState({ attribute: 'loading', data: true })
          const array = this.busTimeline && this.busTimeline.split('-')
          let specificDate = moment.utc(this.time)
          let nextDay = specificDate
            .clone()
            .add(1, 'days')
            .toISOString()
          const params = {
            status: this.status,
            'student.grade': get(this.selectedGrade, 'id'),
            'student.currentClass': get(this.selectedClass, 'id'),
            'student.id': get(this.selectedStudent, 'id'),
            'bus_schedule.periodTime': array && array[0],
            'bus_schedule.direction': array && array[1],
            createdAt_gte: this.time,
            createdAt_lte: nextDay
          }
          await this.fetch({ ...params, _limit: 10, _start: 0 })
          await this.count(params)
          this.setState({ attribute: 'query', data: params })
        } catch (error) {
          this.$alert.error(error)
        } finally {
          this.setState({ attribute: 'loading', data: false })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
